import { c as _c } from "react/compiler-runtime";
import type { Color } from '@onefootprint/design-tokens';
import { IcoBuilding16, IcoBuilding24, IcoHome16, IcoHome24 } from '@onefootprint/icons';
import AddressType from '../../types';
type AddressCardIconProps = {
  type: AddressType;
  color?: Color;
  size?: 'small' | 'large';
};
const AddressCardIcon = t0 => {
  const $ = _c(6);
  const {
    type,
    color: t1,
    size: t2
  } = t0;
  const color = t1 === undefined ? "quinary" : t1;
  const size = t2 === undefined ? "small" : t2;
  if (type === AddressType.residential) {
    let t3;
    if ($[0] !== color || $[1] !== size) {
      t3 = size === "small" ? <IcoHome16 color={color} /> : <IcoHome24 color={color} />;
      $[0] = color;
      $[1] = size;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t3;
  if ($[3] !== color || $[4] !== size) {
    t3 = size === "large" ? <IcoBuilding16 color={color} /> : <IcoBuilding24 color={color} />;
    $[3] = color;
    $[4] = size;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};
export default AddressCardIcon;